module.exports = __webpack_public_path__ + "static/media/image-12.137462f7.webp";